import { TEAM_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const AdminTeamService = {
  getAll: (params: any) => requests.get(`${TEAM_URL}`, params),
  create: (params: any) => requests.post(`${TEAM_URL}`, params, true),
  getSingle: (id: number) => requests.get(`${TEAM_URL}/${id}`),
  update: (params: any, id: number) =>
    requests.post(`${TEAM_URL}/${id}`, params, true),
  updatePosition: (params: any) => requests.patch(`${TEAM_URL}`, params),
  delete: (id: number) => requests.delete(`${TEAM_URL}/${id}`),
};
